import { lazy, Suspense } from 'react';
import { createBrowserRouter, Navigate } from 'react-router';
import { AppLayout } from './components/AppLayout';
import { RequireTerms } from './routes/RequireTerms';
import { RequireAdmin } from './routes/RequireAdmin';
import { RouteError } from './routes/RouteError';
import { PageSpinner } from './components/PageSpinner';
import HomePage from './pages/HomePage';
import AlertsPage from './pages/AlertsPage';
import ReportsPage from './pages/ReportsPage';
import DisclaimersPage from './pages/DisclaimersPage';
import UserProfilePage from './pages/UserProfilePage';
import ContactUsPage from './pages/ContactUsPage';
import TocAcceptancePage from './pages/TocAcceptancePage';

/**
 * Lazy so admin code lands in its own chunk. vite.config.ts forces that chunk
 * under admin/, which is the path CloudFront gates on the signed cookie, and
 * fails the build if it ever leaks elsewhere.
 */
const AdminPage = lazy(() => import('./pages/admin/AdminPage'));

export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    errorElement: <RouteError />,
    children: [
      { index: true, element: <Navigate to="/home" replace /> },

      // Deliberately outside RequireTerms: this is where RequireTerms sends
      // people, so gating it would loop.
      { path: 'toc-acceptance', element: <TocAcceptancePage /> },

      {
        element: <RequireTerms />,
        children: [
          { path: 'home', element: <HomePage /> },
          { path: 'alerts', element: <AlertsPage /> },
          { path: 'reports', element: <ReportsPage /> },
          { path: 'disclaimers', element: <DisclaimersPage /> },
          { path: 'user-profile', element: <UserProfilePage /> },
          { path: 'contact-us', element: <ContactUsPage /> },
          {
            element: <RequireAdmin />,
            children: [
              {
                path: 'admin',
                element: (
                  <Suspense fallback={<PageSpinner message="Loading admin..." />}>
                    <AdminPage />
                  </Suspense>
                ),
              },
            ],
          },
        ],
      },

      { path: '*', element: <Navigate to="/home" replace /> },
    ],
  },
]);
